import { Badge, Text } from "@merge-api/merge-javascript-shared";
import { ChevronRight, Flag as FlagIcon } from "lucide-react";
import MergeTable from "../../../shared/MergeTable";
import IntegrationBuilderEmptyState from "../../../integration-builder/shared/IntegrationBuilderEmptyState";
import { ConductorFlag } from "../types";

interface Props {
  flags: ConductorFlag[];
  onOpen: (flagId: string) => void;
}

// everyone short-circuits evaluation, so it outranks the ruleset in the summary.
const statusBadge = (flag: ConductorFlag) => {
  if (flag.everyone === true) return <Badge color="green">On for everyone</Badge>;
  const active = flag.rules.filter((rule) => rule.enabled !== false).length;
  if (active === 0) return <Badge color="gray">Off</Badge>;
  return <Badge color="blue">{active === 1 ? "1 active rule" : `${active} active rules`}</Badge>;
};

const ConductorFlagsTable = ({ flags, onOpen }: Props) => (
  <MergeTable
    hover={false}
    isOverviewPage
    header={
      <>
        <th scope="col">Name</th>
        <th scope="col">Status</th>
        <th scope="col">Rules</th>
        <th scope="col">Note</th>
        <th scope="col" className="w-16" />
      </>
    }
    content={
      flags.length === 0 ? (
        <IntegrationBuilderEmptyState
          title="No flags"
          subtitle="No conductor flags have been created yet."
          numberOfColumns={5}
          withIcon
          icon={FlagIcon}
        />
      ) : (
        <>
          {flags.map((flag) => (
            <tr key={flag.id}>
              <td>
                <Text variant="md" className="font-medium">
                  {flag.name}
                </Text>
              </td>
              <td>{statusBadge(flag)}</td>
              <td>
                <Text variant="md" className="text-gray-80">
                  {flag.rules.length}
                </Text>
              </td>
              <td>
                <Text variant="md" className="text-gray-60">
                  {flag.note || "-"}
                </Text>
              </td>
              <td>
                <div className="flex justify-end">
                  <button
                    onClick={() => flag.id && onOpen(flag.id)}
                    aria-label={`Open ${flag.name}`}
                    className="rounded p-1 text-gray-60 hover:bg-gray-10 hover:text-gray-90"
                  >
                    <ChevronRight size={22} />
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </>
      )
    }
  />
);

export default ConductorFlagsTable;
